/* eslint-disable react-hooks/exhaustive-deps */
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";

import { useEffect, useState } from "react";
import DefaultApiService from "../../../infrastructure/api/default";
import { ModalTransition } from "../shared/Dialog/Config";
import LoadingWrapper from "../shared/loading";

const CounterDetailDialog = ({ open, onClose, positionId }) => {
  const [loading, setLoading] = useState(false);
  const [counterInfo, setCounterInfo] = useState({});

  useEffect(() => {
    if (positionId) {
      onGetCounterDetail(positionId);
    }
  }, [positionId]);

  const onGetCounterDetail = async () => {
    try {
      const res = await DefaultApiService.getApi(
        "GV/SingleLineDiagram/GetCounterDetails",
        {
          positionId: positionId,
        }
      );
      console.log("res", res?.data[0]);
      setCounterInfo(res?.data[0]);
      setLoading(false);
    } catch (error) {
      toast.error("خطایی رخ داده است.");
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={ModalTransition}
      keepMounted
      onClose={onClose}
      maxWidth={"md"}
      className="dialog-wrapper danger"
    >
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <IconButton onClick={onClose}>
              <ClearIcon />
            </IconButton>
          </Grid>
          <Grid item xs={12} md={12} container className="custom-table">
            {loading ? (
              <LoadingWrapper />
            ) : (
              <>
                <Grid item xs={12} md={12} className="row header">
                  <Typography
                    variant="h6"
                    fontWeight={"bold"}
                    color={"primary"}
                  >
                    {`اطلاعات کنتور ${counterInfo.serial}`}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={12} className="row" container>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      مالکیت ایستگاه
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.companyName}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      شهرستان
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.cityName}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} className="row" container>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      ایستگاه
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.substationName}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      شماره ترانس
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.transNumber}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} className="row" container>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      شماره فیدر
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.feederName}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      سریال کنتور
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.serial}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} className="row" container>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      مدل کنتور
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.counterModel}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      شروع بهره برداری
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.positionActDate}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} className="row" container>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      وضعیت کنتور
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.counterStatus}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      کد GIS
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.transGISCode}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} className="row" container>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      بیشینه مجاز فیدر(MW)
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.transMaxRange}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      کمینه مجاز فیدر(MW)
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.transMinRange}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} className="row" container>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      نوع مالکیت فیدر
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.ownershipKind}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} container>
                    <Grid item xs={6} md={6} className="cell title">
                      نوع فیدر
                    </Grid>
                    <Grid item xs={6} md={6} className="cell value">
                      {counterInfo.feederKind}
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions className="buttons-wrapper">
        <Button variant="outlined" size="large" onClick={onClose}>
          بستن
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CounterDetailDialog;
